export default "__VITE_ASSET__d86b57a8__"